// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

// TYPES ---------------------------------------------------------------- //

export interface AdornmentProps {
  id: string | number;
  element?: React.ReactElement;
  style?: React.CSSProperties;
}

// COMPONENT ---------------------------------------------------------------- //

const Adornment = ({ element, style }: AdornmentProps) => {
  if (!element) return null;
  return <div style={style}>{element}</div>;
};

// EXPORT ---------------------------------------------------------------- //

export default Adornment;
